import {
    Button,
    Grid,
    Glyphicon,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Table,
} from "react-bootstrap";
import ImagePreview from "../ImagePreview";
import Loader from "../Loader";
import PageButtons from "../PageButtons";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import * as managerStatus from "../../enums/managerStatus";
import * as colors from "../../styles/colors";
import * as managers from "../../lib/api/managers";
import PropTypes from "prop-types";
import logger from "../../lib/logger";

const styles = StyleSheet.create({
    imageWrapper: {
        textAlign: "center",
        width: 90,
    },
    editWrapper: {
        textAlign: "center",
        width: 80,
    },
    verticalCenter: {
        verticalAlign: "middle",
        fontSize: 16,
    },
    error: {
        color: colors.red,
    },
    center: {
        textAlign: "center",
    },
});

const PAGE_SIZE = 20;

const strings = {
    title: "Managers | Habit CMS",
    filterByName: "Filter by name:",
    filterByTitle: "Filter by title:",
    filterByStatus: "Filter by status:",
    enterText: "Enter text",
    name: "Name",
    qaCompleted: "Q+A Completed",
    edit: "Edit",
    of: "of",
};

export default class ManagersPage extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
    };

    state = {
        loading: true,
        managers: [],
        total: 0,
        totalQuestionCount: 0,
        currentPage: 0,
        name: "",
        status: managerStatus.all.value,
        title: "",
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
        this._loadManagers();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _loadManagers = page => {
        if (!page) {
            page = 0;
        }
        if (!this.state.loading) {
            this.setState({ loading: true });
        }
        managers
            .getManagers(
                page * PAGE_SIZE,
                page * PAGE_SIZE + PAGE_SIZE,
                this.state.name,
                this.state.title,
                this.state.status,
            )
            .then(resp => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        managers: resp.managers,
                        total: resp.total,
                        totalQuestionCount: resp.totalQuestionCount,
                        currentPage: page,
                    });
                }
            })
            .catch(err => logger.warn(err));
    };

    _editManager = id => {
        this.props.history.push(`/manager/${id}`);
    };

    _handleNameChange = e => {
        this.setState({ name: e.target.value }, this._loadManagers);
    };

    _handlePageChange = page => {
        this._loadManagers(page - 1);
    };

    _onFilterStatusChange = e => {
        this.setState({ status: e.target.value, loading: true }, this._loadManagers);
    };

    render() {
        return (
            <Grid>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="name">
                            <ControlLabel>{strings.filterByName}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder={strings.enterText}
                                onChange={this._handleNameChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup controlId="title">
                            <ControlLabel>{strings.filterByTitle}</ControlLabel>
                            <FormControl componentClass="select">
                                <option value="all">All</option>
                                <option value="manager">Manager</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup controlId="status">
                            <ControlLabel>{strings.filterByStatus}</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={this.state.status}
                                onChange={this._onFilterStatusChange}
                            >
                                <option value={managerStatus.all.value}>
                                    {managerStatus.all.label}
                                </option>
                                <option value={managerStatus.missingPhoto.value}>
                                    {managerStatus.missingPhoto.label}
                                </option>
                                <option value={managerStatus.missingAllQA.value}>
                                    {managerStatus.missingAllQA.label}
                                </option>
                                <option value={managerStatus.missingSomeQA.value}>
                                    {managerStatus.missingSomeQA.label}
                                </option>
                                <option value={managerStatus.complete.value}>
                                    {managerStatus.complete.label}
                                </option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th />
                                    <th>{strings.name}</th>
                                    <th>{strings.title}</th>
                                    <th>{strings.qaCompleted}</th>
                                    <th>{strings.edit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!this.state.loading &&
                                    this.state.managers.map((m, i) => {
                                        const hasImage = m.images && m.images.length;
                                        return (
                                            <tr key={i}>
                                                <td
                                                    className={`${css(styles.imageWrapper)} ${
                                                        hasImage
                                                            ? ""
                                                            : ` danger ${css(styles.error)}`
                                                    }`}
                                                >
                                                    <ImagePreview height={70} image={m.images} />
                                                </td>
                                                <td className={css(styles.verticalCenter)}>
                                                    {m.name}
                                                </td>
                                                <td className={css(styles.verticalCenter)}>
                                                    {m.title}
                                                </td>
                                                <td
                                                    className={`${
                                                        m.completedQuestionCount === 0
                                                            ? "danger"
                                                            : ""
                                                    } ${css(styles.verticalCenter)}`}
                                                >
                                                    {m.completedQuestionCount} /{" "}
                                                    {this.state.totalQuestionCount}
                                                    {m.completedQuestionCount === 0 ? (
                                                        <span className={css(styles.error)}>
                                                            <Glyphicon glyph="exclamation-sign" />
                                                        </span>
                                                    ) : null}
                                                </td>
                                                <td
                                                    className={css(
                                                        styles.verticalCenter,
                                                        styles.editWrapper,
                                                    )}
                                                >
                                                    <Button
                                                        bsStyle="primary"
                                                        onClick={() => this._editManager(m.id)}
                                                    >
                                                        {strings.edit}
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </Table>
                        {this.state.loading ? <Loader /> : null}
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <div>
                            {Math.min((this.state.currentPage + 1) * PAGE_SIZE, this.state.total)}{" "}
                            {`${strings.of} `}
                            {this.state.total}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className={css(styles.center)}>
                        <PageButtons
                            numPages={this.state.total / PAGE_SIZE}
                            currentPage={this.state.currentPage + 1}
                            handlePageChange={this._handlePageChange}
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }
}
